/** @jsx jsx */
import { FC, useEffect } from "react";
import { jsx } from "@emotion/react";
import { Button, Tooltip } from "@material-ui/core";
import { useFormatMsg } from "src/hooks/useFormatMsg";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { getTooltipString, getUniqueInputId } from "./utils";

import * as S from "./styles";

interface Props {
  disabled?: boolean;
  multiple?: boolean;
  onFileChange(newFiles: FileList): void;
}

const FileInput: FC<Props> = ({
  onFileChange,
  disabled = false,
  multiple = true,
}) => {
  const formatMsg = useFormatMsg();

  const handleChangeFile = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (e.currentTarget && e.currentTarget.files) {
      onFileChange(e.currentTarget.files);
      // eslint-disable-next-line no-param-reassign
      e.currentTarget.value = "";
    }
  };

  const inputId = getUniqueInputId(); // potřebné pro jedinečné id u každého inputu v tabulce
  return (
    <div css={S.fileInputCss}>
      <label htmlFor={inputId} style={{ marginBottom: 0 }}>
        <input
          type="file"
          multiple={multiple}
          id={inputId}
          onChange={handleChangeFile}
          css={S.hideInputCss}
          disabled={disabled}
          enterKeyHint="done"
        />

        <Tooltip title={getTooltipString(disabled, formatMsg)} arrow>
          <Button
            css={disabled ? S.uploadButtonDisabledCss : S.uploadButtonCss}
            variant="contained"
            component="div"
          >
            <CloudUploadIcon fontSize="small" />
          </Button>
        </Tooltip>
      </label>
    </div>
  );
};

export default FileInput;
export type FileInputProps = Props;
